import React from 'react'
import styles from './joinPlatform.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import parse from 'html-react-parser';
const JoinPlatform = (props) => {
    return (
        <section className={`${styles.ourStatistics} ourStatistics ourStatistics_pricing`}>
            <Container className='h-100'>
                <Row className="h-100 justify-content-center gx-0">
                    <Col lg={12}>
                        <h1>{props?.widgetData?.heading}  </h1>
                        <div className={`${styles.boxes} ${styles.wrape_info}  ${styles.wrape_infoPricingPage} row  justify-content-center align-items-end`}>
                            <Col lg={3} data-aos="fade-right" data-aos-duration="3000">
                                <div className={`${styles.box1} ${styles.boxDesign}  box1DrNow`} >
                                    <div>
                                        <div className={styles.iconLink}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clip-path="url(#clip0_7474_2908)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.63734 16.8611L14.264 8.23443L6.35434 8.24432L6.35682 6.2669L17.6564 6.25276L17.6422 17.5523L15.6648 17.5548L15.6747 9.6451L7.04801 18.2718L5.63734 16.8611Z" fill="#0F345A" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_7474_2908">
                                                        <rect width="24" height="24" fill="white" transform="translate(0 -0.000305176)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <h2> {parse(props?.widgetData?.data?.[0]?.heading)} </h2>
                                        <p> {parse(props?.widgetData?.data?.[0]?.description)}  </p>
                                    </div>
                                    {props?.widgetData?.data?.[0]?.image && <img src={props?.widgetData?.data?.[0]?.image} className='img-fluid' />}
                                </div>
                            </Col>
                            <Col data-aos="fade-right" data-aos-duration="3000" lg={3} xs={12} className='or4'>
                                <div className={`${styles.box2} ${styles.boxDesign} box2DrNow`}  >
                                    {props?.widgetData?.data?.[1]?.image && <img src={props?.widgetData?.data?.[1]?.image} className='img-fluid' />}
                                    <h2> {parse(props?.widgetData?.data?.[1]?.heading)} </h2>

                                    <p> {parse(props?.widgetData?.data?.[1]?.description)} </p>
                                </div>
                            </Col>
                            <Col data-aos="fade-up" data-aos-duration="3000" lg={3} xs={12} className='or3'>
                                <div className={`${styles.box3} ${styles.boxDesign} box3DrNow`}  >
                                    <h2>  {props?.widgetData?.data?.[2]?.heading} </h2>
                                    <p>  {props?.widgetData?.data?.[2]?.description} </p>
                                    {props?.widgetData?.data?.[2]?.image && <img src={props?.widgetData?.data?.[2]?.image} className='img-fluid' />}

                                </div>
                            </Col>
                            <Col data-aos="fade-left" data-aos-duration="3000" lg={3} xs={12} className='or5'>
                                <div className={`${styles.box4} ${styles.boxDesign} box4DrNow`} >
                                    {props?.widgetData?.data?.[3]?.image && <img src={props?.widgetData?.data?.[3]?.image} alt='' className={styles.doc__img_sta} />}
                                    <h2> {props?.widgetData?.data?.[3]?.heading}  </h2>
                                    <p> {props?.widgetData?.data?.[3]?.description}  </p>
                                </div>
                            </Col>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
export default JoinPlatform;
